module.exports = __webpack_public_path__ + "img/forbes-yellow.00040df6.svg";